





































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Document } from "@/model/document2/document";
import { InsertionData } from "@/model/document2/insertionData/insertionData";

import { UuidHelper } from '@/helper/uuidHelper';

import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper";
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";

import { Vector2 } from '@/utilityModels/vector2';

import ping from '@/helper/ping';
import pass from '@/helper/pass';

@Component({
  components: {
      CheckBoxOn
  }
})
export default class TableView extends Vue
{
    // 最低限この行・列数は画面上に表示する
    static readonly VIEW_ROW_MIN = 10;
    static readonly VIEW_COLUMN_MIN = 10;

    // セルの大きさ
    static readonly CELL_WIDTH = 130;
    
    // ieが勝手にblurするので不要な場合は止める
    private canBlurCell: boolean = true;

    // 印刷一斉選択のチェック状態
    private get isCheckPrintAll() : boolean
    {
        // すべてのrowにおける選択状態
        // すべて .print == true なら -> true
        // それ以外 -> false
        var isCheck = true;
        for(var i = 0; i < this.rows.length; ++i)
        {
            var row = this.rows[i];
            if(!row.print)
            {
                isCheck = false;
                break;
            }
        }
        return isCheck;
    }

    mounted(){
        if (UserAgentHelper.isElectron()) {
            // URLの有効性確認がうまく動かないのでElectronのみ
            const inputs = this.$refs.inputs as HTMLInputElement[];
            for (let input of inputs) {
                this.validateColumn(input);
            }
        }
    }

    // 差し込みを示す矢印の中心座標を得る
    public getInsertionArrowPosition(columnIndex : number) : Vector2
    {
        var key = 'insertion-arrow_' + columnIndex;
        var img = document.getElementById(key);
        var rect = img ? img.getBoundingClientRect() : new DOMRect();
        return new Vector2(rect.left + rect.width / 2, rect.top);
    }

    onDoCommand(command: string, paramater: any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private get currentDocument() : Document
    {
        return this.$store.getters.document;
    }

    private get currentInsertionData() : InsertionData
    {
        return this.currentDocument.insertionData;
    }

    private get cellStyle()
    {
        return {
            width : TableView.CELL_WIDTH + "px"
        }
    }

    private getCellStyle(cellItem)
    {
        var isSelected = this.currentDocument.selectedInsertionRow == cellItem.row && this.currentDocument.selectedInsertionColumn == cellItem.column;
        var isSelectedColumn = this.currentDocument.selectedInsertionWholeColumn == cellItem.column;
        var borderColor = this.$store.getters.userConfigColors.buttonColorCode;
        return {
            "width" : TableView.CELL_WIDTH + "px",
            "border" : isSelected ? "solid " + borderColor : "none",
            "height" : "32px",
            "-moz-box-sizing": "border-box",
            "-webkit-box-sizing": "border-box",
            "-o-box-sizing": "border-box",
            "-ms-box-sizing": "border-box",
            "box-sizing": "border-box",
            "backgroundColor" : isSelectedColumn ? this.userConfigRgbaColor : "transparent"
        }
    }

    // :hover
    private onMouseenterEvent(e)
    {
        e.target.style.backgroundColor = this.$store.getters.userConfigColors.buttonColorRgba;
    }

    // :not(:hover)
    private onMouseleaveEvent(e, column)
    {
        if(this.currentDocument.selectedInsertionWholeColumn != column){ e.target.style.backgroundColor = ""; }
    }

    private get tableStyle()
    {
        let width = 42 * 3 + TableView.CELL_WIDTH * this.columnHeaders.length;
        return {
            width : width + "px"
        }
    }

    private get columnHeaders()
    {
        var array = new Array();
        for(var col = 0; col < this.currentInsertionData.getColumnDataCount(); ++col)
        {
            var label = "";
            // 1行目を列名にするが有効な場合は、1行目から取得する
            if(this.currentInsertionData.isFirstRowAsColumnName)
            {
                var cellData = this.currentInsertionData.getCellData(0, col);
                if(cellData != null) { label = cellData.content; }
            }

            // 1行目を列名にするが無効、もしくは1行目のセルが空だった場合はヘッダーテキストを使う
            if(label == "")
            {
                var columnData = this.currentInsertionData.getColumnData(col);
                label = columnData.headerText;
            }

            array.push({
                label : label,
                key : UuidHelper.getUuid(),
                column : col
            });
        }
        return array;
    }

    private get rows()
    {
        var array = new Array();
        var startRow = this.currentInsertionData.isFirstRowAsColumnName ? 1 : 0;
        for(var i = startRow; i < this.currentInsertionData.getRowDataCount(); ++i)
        {
            var rowData = this.currentInsertionData.getRowData(i);
            var cells = new Array();
            for(var j = 0; j < rowData.cellDataArray.length; ++j)
            {
                var cellData = rowData.cellDataArray[j];
                var label = cellData.content;
                cells.push({
                    label : label,
                    key : UuidHelper.getUuid(),
                    row : i,
                    column : j
                });
            }
            // Numberは「１行目を列名にする」がONのときは、1始まりで表示されるように調整する
            let number = this.currentInsertionData.isFirstRowAsColumnName ? i : i + 1;
            array.push({
                printCount : "" + rowData.printCount,
                cells : cells,
                hasData : true,
                number : "" + number,
                print : rowData.isPrint,
                key : UuidHelper.getUuid(),
                row : i
            });
        }

        DebugHelper.trace(array)
        return array;
    }

    // 列をクリックする
    private onClickColumn(column)
    {
        // 選択中の列を再度クリックした場合は選択を解除
        this.currentDocument.selectedInsertionColumn = column;
        this.currentDocument.selectedInsertionWholeColumn = this.currentDocument.selectedInsertionWholeColumn == column ? -1 : column;

        if(this.currentDocument.selectedInsertionWholeColumn >= 0){ this.onDoCommand("historyLine", null); }
        // 列クリックイベントを送信
        this.$emit("columnClicked");
    }

    // セルをクリックする
    private onClickCell(cellItem)
    {
        // 選択しているセルには何もしない
        if (this.currentDocument.selectedInsertionRow === cellItem.row &&
            this.currentDocument.selectedInsertionColumn === cellItem.column &&
            this.currentDocument.selectedInsertionWholeColumn === -1
        ) return true;

        this.currentDocument.selectedInsertionColumn = cellItem.column;
        this.currentDocument.selectedInsertionWholeColumn = -1;

        // 列選択するとデザインを変更する必要があるので、イベントで行う
        this.onDoCommand("selectRow", { row : cellItem.row });
    }

    private onChangedText(e)
    {
        const input = e.target as HTMLInputElement;
        if (!input) {
            DebugHelper.trace('input is not found');
            return false;
        }
        const params = {
            text: input.value,
            row: this.currentDocument.selectedInsertionRow,
            column: this.currentDocument.selectedInsertionColumn,
            isFinish: true // 使ってないかも
        }
        this.onDoCommand("changeCellText", params);
        if (UserAgentHelper.isElectron()) {
            // URLの有効性確認がうまく動かないのでElectronのみ
            this.validateColumn(input);
        }
    }

    private submitPrintCount(e, rowItem)
    {
        const input = e.target as HTMLInputElement;
        let value = parseInt(input.value, 10);  // IEだとvalueAsNumberが使えない
        if (isNaN(value) || value < 0) {
            // ViewModelが更新されなくてもViewは更新する
            input.value = '0';
            value = 0;
        }

        if (rowItem.cells.length > 0) {
            // 列がないと更新できない
            this.changePrintCount(rowItem.cells[0].row, value);
        }
    }

    private changePrintCount(row: number, value: number)
    {
        this.onDoCommand('changePrintCount', {row, value});
    }

    private changePrint(isPrint : boolean, row : number)
    {
        this.onDoCommand("changePrint", { isPrint : isPrint, row : row });
    }

    // 印刷一斉変更
    private changePrintAll()
    {
        // ON状態ならすべて印刷OFFにする
        // OFF状態ならすべて印刷ONにする
        var isPrint = !this.isCheckPrintAll;
        // "1行目を列名にする"がONでも、1行目まで含めて変更する
        for(var i = 0; i < this.currentInsertionData.getRowDataCount(); ++i)
        {
            this.onDoCommand("changePrint", { isPrint : isPrint, row : i });
        }
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    private onScrolled()
    {
        this.$emit("tableScrolled");
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
    private get userConfigBackgroundColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }
    private get userConfigRgbaColor(){
        return this.$store.getters.userConfigColors.buttonColorRgba;
    }

    private get rowStyle(){
        var style = {};
        if(UserAgentHelper.getBrowser() != "ie"){
            style = {
                top : "11px",
                width : TableView.CELL_WIDTH + "px"
            }
        }else{
            style = {
                width : TableView.CELL_WIDTH + "px"
            }
        }
        return style;
    }

    // Columnの正当性を確かめる
    private validateColumn(input: HTMLInputElement) {
        const value = input.value.trim();
        // URLなら有効性を確認する
        const check = (/^(https?:\/\/|file:\/\/)/.test(value)) ? ping(value) : pass();
        check.then(() => {
            input.style.background = '';
            input.title = '';
        }).catch(() => {
            input.style.background = '#faa';
            input.title = '指定されたURLは存在しません';
        });
    }
}

